export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/materialType/state.js